<template>
  <v-menu v-if="user" offset-y bottom left>
    <v-btn flat slot="activator">
      <v-avatar v-if="user.avatar_url" size="32px" class="mr-2">
        <v-img :src="user.avatar_url + '&s=30'" aspect-ratio="1"/>
      </v-avatar>
      <template v-else>
        <v-icon large>mdi-account-circle</v-icon>
      </template>
      <span class="hidden-sm-and-down">
        <template v-if="user.first_name">
          {{user.first_name}}
        </template>
        <v-icon>arrow_drop_down</v-icon>
      </span>
    </v-btn>
    <v-list>
      <v-list-tile class="profile-hint no-wrap">
        {{user.full_name}}<br/>
        {{user.login_at | moment('MM/DD/YYYY hh:mm A [PT]z')}}
      </v-list-tile>
      <v-list-tile to="/items" class="hidden-md-and-up">
        <v-list-tile-title>
          <v-icon>mdi-format-list-bulleted</v-icon>
          Items
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile to="/orders" class="hidden-md-and-up">
        <v-list-tile-title>
          <v-icon>mdi-format-list-numbered</v-icon>
          Orders
        </v-list-tile-title>
      </v-list-tile>
      <v-divider class="hidden-md-and-up"/>
      <v-list-tile to="/account">
        <v-list-tile-title>
          <v-icon>mdi-account</v-icon>
          Account
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile disabled to="">
        <v-list-tile-title>
          <v-icon>mdi-message-bulleted</v-icon>
          What's New
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="hasStore" :href="storeUrl" target="_blank">
        <v-list-tile-title>
          <v-icon>mdi-store</v-icon>
          View Store
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-else href="https://www.gungho.com/store" target="_blank">
        <v-list-tile-title>
          <v-icon>mdi-store</v-icon>
          Get A Store
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="hasStore" :href="storeEditUrl" target="_blank">
        <v-list-tile-title>
          <v-icon>mdi-pencil</v-icon>
          Edit Store
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="hasStore" :href="storeReportUrl" target="_blank">
        <v-list-tile-title>
          <v-icon>mdi-finance</v-icon>
          Sales Report
        </v-list-tile-title>
      </v-list-tile>
      <template v-if="isAdmin">
        <v-divider/>
        <template v-for="item in adminMenu">
          <v-list-tile :to="item.href">
            <v-list-tile-title>
              <v-icon>{{ item.icon }}</v-icon>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile>
        </template>
      </template>
      <v-divider/>
      <v-list-tile target="_blank" :href="helpUrl" class="hidden-md-and-up">
        <v-list-tile-title>
          <v-icon>mdi-help-circle</v-icon>
          Help
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile :href="logoutUrl">
        <v-list-tile-title>
          <v-icon>mdi-logout-variant</v-icon>
          Log Out
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<style scoped lang='sass'>
  .profile-hint
    background: #000
    color: #eee
    margin-top: -8px
    .list__tile
      font-size: 13px !important
</style>

<script>
  export default {
    data () {
      return {
        profileMenu: [
          {icon: 'mdi-account', text: 'Profile', href: '/profile'},
          {icon: 'mdi-pencil', text: 'Store', href: this.storeEditUrl},
          {icon: 'mdi-chart-line-variant', text: 'Sales', href: this.storeReportUrl}
        ],
        adminMenu: [
          {icon: 'mdi-view-dashboard', text: 'Dashboard', href: '/admin/reports'},
          {icon: 'mdi-format-list-numbered', text: 'Orders', href: '/admin/orders'},
          {icon: 'mdi-account-multiple', text: 'Users', href: '/admin/users'},
          {icon: 'mdi-account-network', text: 'Affiliates', href: '/admin/affiliates'},
          {icon: 'mdi-settings', text: 'Settings', href: '/admin/settings'},
          {icon: 'mdi-wrench', text: 'System', href: '/admin/system'}
        ]
      }
    },

    beforeMount () {
      this.$store.dispatch('loadUser')
    },

    computed: {
      user () {
        return this.$store.state.user
      },

      contactUrl () {
        return process.env.CONTACT_URL
      },

      helpUrl () {
        return process.env.HELP_URL
      },

      logoutUrl () {
        return process.env.LOGIN_URL + '/logout?to=' +
               window.location.href + '&t=' + this.$session.get('sessionToken')
      },

      companyName () {
        if (!this.user || !this.user.company_name) return
        return this.user.company_name
      },

      storeSubdomain () {
        if (!this.companyName) return this.user.id
        return this.companyName.replace(/[^0-9a-z]/gi, '')
      },

      storeUrl () {
        return process.env.STORE_URL.replace('*', this.storeSubdomain) +
          '/?t=' + this.$session.get('sessionToken')
      },

      storeEditUrl () {
        return this.storeUrl + '&edit=true'
      },

      storeReportUrl () {
        return process.env.STORE_URL.replace('*', this.storeSubdomain) +
          '/reports?t=' + this.$session.get('sessionToken')
      },

      isAdmin () {
        return this.$store.getters.isAdmin
      },

      hasStore () {
        if (!this.user.features) return false
        return this.$store.getters.features.includes('store')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// profile-menu.vue?3610a934